import auth from './auth';
import Pixel from './Meta/Pixel';
import React, { useState, useRef, useEffect } from 'react';
import BlueLogo from "../Resources/logo-blue.png";
import ReactLoading from 'react-loading';
import { useAlert } from 'react-alert';
import { PinNumberPage } from './PinNumberPage';
import { MobileNumberPage } from './MobileNumberPage';
import { AdditionalInputPage } from './AdditionalInputPage';

export const Login = props => {
  const [notLoading, setNotLoading] = useState(true);
  const [mobileNumber, setMobileNumber] = useState('');
  const [pinNumber, setPinNumber] = useState('');
  const [memberNumber, setMemberNumber] = useState(null);
  const [timerCountdown, setTimerCountdown] = useState(null);
  const [dob, setDob] = useState(null);
  const [page, setPage] = useState(0);
  
  const [pinFailCounter, setPinFailCounter] = useState(0);

  //Clears the sessionstorage to prevet user from clicking forward to log back in without having to enter in credentials
  React.useEffect(()=>{
    Pixel.sendTrack('PageView');

    sessionStorage.clear();
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect( () => {
    if(pinNumber.length === 6){
      confirmOTP();
    }
  }, [pinNumber])

  async function activatePinPage(){
    setPage(1);
  }

  //#endregion
  function errorAlert(){
    alert.show("Your request currently cannot be processed. Please check if the information your provided was correct and try again.", {
        title: "An error has occured"
      });
  }  

  async function generateOTP(ev=null) {
    
    if(ev){
      ev.preventDefault();
    }

    setNotLoading(false);
    sessionStorage.setItem("mobileNumber", mobileNumber);
      try {
       await auth.generateOTP(mobileNumber, activatePinPage, errorAlert)
      } catch (exception) {
        console.error(exception);
        alert.show("Your request currently cannot be processed. Please try again.", {
          title: "An error has occured"
        });
      } 
      finally{
        setNotLoading(true);
        const timer = Date.now() + 300000;
        setTimerCountdown(timer);
      }
  }

  async function confirmOTP(ev=null) {

    if(ev){
      ev.preventDefault();
    }

    setNotLoading(false);
    const DTO = { mobileNumber, pinNumber, memberNumber, dob };
    const counter = pinFailCounter + 1;
    setPinFailCounter(counter);

    try {
      const data = await auth.confirmOTP(DTO, 2, counter);

      if (data.status === 401) {
        if(counter < 3){
          alert.show(data.message, {
            title: "An error has occured"
          });
        }
        else {
          alert.show(data.message, {
            title: "An error has occured",
            onClose: () => {window.location.reload();}
          });
        }
      }
      else if (data.status === 200){

        if (data.message === 'Need Member Number'){
          setPage(2);
        }

        else if (data.message === 'Need DOB'){
          setPage(3);
        }

        else if (data.message === 'No Member'){
          signUp();
        }

        else if (data.message === 'Incorrect Details'){
          throw new Error('Incorrect credentials');
        }

        else if (data.message === 'Non-Current'){
          alert.show("Please visit our club to reactivate your membership.", {
            title: "Membership Has Expired",
            onClose: () => {props.history.push('/home')}
          });
        }

        else{
          sessionStorage.setItem('memberNumber', data.memberNumber);
          sessionStorage.setItem("loggedIn", true);
          sessionStorage.setItem("token", data.token);
          sessionStorage.setItem('fullName', data.FullName);
          sessionStorage.setItem('photo', data.photo);
          sessionStorage.setItem('cardNumber', data.cardNumber.toString());

          setTimeout(() => {
          props.history.push("/home");
          }, 1000);
        }  
      } 
      else{
        throw new Error('Status not 200 or 401');
      }

    } catch (error) {
      console.error(error);
      alert.show("We are unable to process your request at this time. Please contact us at 9722 9888", {
        title: "An error has occured",
        onClose: () => {props.history.push('/home')}
      });
    } finally {
      setNotLoading(true);
    }
  }

    const signUp = () =>{
      props.history.push('/signup',{clubID: null,mobileNumber});
    }

  const alert = useAlert();

  return (
    <div>
      <div className="overlay" hidden={notLoading}>
        <ReactLoading className="loading" type={'cylon'} color={'#61dafb'} height={300} width={300} />
      </div>
      <img alt="Bankstown Logo" className="oauth-image" src={BlueLogo} />
      <div className="mini-form container">
        <h2><strong>LOGIN/JOIN</strong></h2>
          {
            page === 0 && 
            <>
            <MobileNumberPage mobileNumber={mobileNumber} setMobileNumber={setMobileNumber} generateOTP={generateOTP}/>
            </>
          }
          {
                page === 1 && 
                 <PinNumberPage timerCountdown={timerCountdown} pinNumber={pinNumber} setPinNumber={setPinNumber}/>
            }
            {
            page === 2 && <AdditionalInputPage parameter={"Member Number"} setParameter={setMemberNumber} confirmOTP={confirmOTP}/>
          }
           {
            page === 3 && <AdditionalInputPage parameter={"Date of Birth"} setParameter={setDob} confirmOTP={confirmOTP}/>
          }
        <br></br>

        {(window.location.origin === 'http://localhost:3000' || window.location.origin === 'https://customers.bscdev.com.au') &&
        <a href={window.location.origin + "/oauth?client_id=dWFLzZI59xL4Il6fZ9h8Dwpaal6jUI4Z&redirect_uri=http://localhost:3000/login"}>OAUTH Test</a>
        }
      </div>
    </div>
  )
}